import React, { useState } from "react";

type propTypes = {
  className: string;
  getValue: (otp: string) => void;
};

const PinInputOne = ({ getValue, className }: propTypes) => {
  const [pin, setPin] = useState<string[]>(new Array(5).fill(""));

  // Handle digit input
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value;

    if (/^\d{0,1}$/.test(value)) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);
      getValue(newPin.join(""));

      if (value && index < 4) {
        document.getElementById(`auth-c-${index + 1}`)?.focus();
      }
    }
  };

  // Handle backspace key
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      const newPin = [...pin];
      newPin[index - 1] = "";
      setPin(newPin);
      getValue(newPin.join(""));

      document.getElementById(`auth-c-${index - 1}`)?.focus();
    }
  };

  // Handle pasting of OTP
  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedText = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 5);
    const newPin = pastedText.split("").concat(new Array(5 - pastedText.length).fill(""));
    setPin(newPin);
    getValue(newPin.join(""));
  };

  // Clear the input fields
  const clearPin = () => {
    setPin(new Array(5).fill(""));
    getValue("");
  };

  return (
    <div className="flex items-center gap-4">
      {/* PIN Input Fields */}
      <div className="grid grid-cols-5 gap-2">
        {[...Array(5)].map((_, index) => (
          <input
            key={index}
            id={`auth-c-${index}`}
            className={className}
            type="password"
            maxLength={1}
            value={pin[index] ? "*" : ""}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={handlePaste}
            autoComplete="off"
            inputMode="numeric"
            pattern="\d*"
          />
        ))}
      </div>

      {/* Clear Button with 'btn-secondary-1' class */}
      <button className="btn-secondary-1" onClick={clearPin}>
        Clear
      </button>
    </div>
  );
};

export default PinInputOne;

